/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
  general: {
    breakpointMobile: 1024
  },
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
    breakpointMobile: 1024,
    // suggestionMobileStyle: 'style1',
    // suggestionStyle: 'style3'
  }
};

(function () {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function () {
    var suggestionElement = this.$uiMenuElement;
    var searchElement = this.$element;
    var searchBoxId = this.id;
  };

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function () {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function (e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }

  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function () {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function (e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function () {
    setTimeout(function () {
      boostPFS.initSearchBox();
      if (Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

  InstantSearchResultItemProduct.prototype.setData = function (data) {
    if (data) {
      this.data = data;
      this.id = data.id;
      this.title = Utils.stripHtml(data.title);
      this.imageUrl = data.images_info.length > 0 ? Utils.optimizeImage(data.images_info[0].src, '540x') : boostPFSConfig.general.no_image_url;
      this.url = Utils.buildProductItemUrl(data, false);
      this.sku = Utils.stripHtml(data.skus && data.skus.length > 0 ? data.skus[0] : '');
      this.label = Utils.stripHtml(data.label);
      this.vendor = Utils.stripHtml(data.vendor);
      this.isShow = true;
    } else {
      this.data = null;
      this.id = '';
      this.title = '';
      this.imageUrl = '';
      this.url = '';
      this.sku = '';
      this.label = '';
      this.vendor = '';

      this.isShow = false;
    }
  }

})();